// =============================================
// SERVICIO DE BACKUP
// =============================================

import api from './api';

const backupService = {
  // Obtener estado y lista de backups
  getStatus: async () => {
    const response = await api.get('/backup/status');
    return response.data;
  },

  // Listar backups disponibles
  listBackups: async () => {
    const response = await api.get('/backup/list');
    return response.data;
  },

  // Ejecutar backup completo
  executeFullBackup: async () => {
    const response = await api.post('/backup/full');
    return response.data;
  },

  // Ejecutar backup de base de datos
  executeDatabaseBackup: async () => {
    const response = await api.post('/backup/database');
    return response.data;
  },

  // Ejecutar backup de archivos
  executeFilesBackup: async () => {
    const response = await api.post('/backup/files');
    return response.data;
  },

  // Descargar backup
  downloadBackup: async (filename) => {
    const response = await api.get(`/backup/download/${filename}`, {
      responseType: 'blob'
    });
    
    // Crear link de descarga
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    return { success: true };
  },
};

export default backupService;
